import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Drawer, DrawerProps, notification } from 'antd';

import { useBrandsSlice, useJoinBrandsMutation } from 'entities/Brand';
import { useDisableBodyScroll, useMeta } from 'shared/hooks';
import { EYmEvents, EYmEventsO1, EYmEventsO2 } from 'shared/typings';
import { JoinForm } from 'shared/ui';
import { sendYmEvent } from 'shared/utils';

interface IJoinBrandProps extends DrawerProps {}

export const JoinBrand: FC<IJoinBrandProps> = ({ ...props }) => {
	const { t } = useTranslation();
	const { joinedBrand, joinedSources, setJoinedBrand, setJoinedSources } = useBrandsSlice();
	const [joinBrands, { status, isLoading }] = useJoinBrandsMutation();
	const { activeSourcesOptions, sourceCanJoin } = useMeta();

	const sourceOptions = activeSourcesOptions.filter(({ value: sourceUuid }) =>
		joinedBrand?.offers.some((offer) => sourceCanJoin(sourceUuid, offer.sources_relations)),
	);

	useDisableBodyScroll(!!joinedBrand);

	useEffect(() => {
		if (status === 'fulfilled') {
			sendYmEvent({
				event: EYmEvents.SEND_JOIN_SUCCESS,
				o1: [EYmEventsO1.ACCOUNT, EYmEventsO1.PUBLISHER, EYmEventsO1.CATALOG],
				o2: EYmEventsO2.JOIN,
				pi: joinedBrand?.uuid,
				wi: joinedSources?.join(';'),
			});

			setJoinedBrand(null);
			setJoinedSources(null);
			notification.open({
				message: t('Заявка отправлена успешно'),
				description: t('После прохождения модерации ваши площадки будут подключены к офферу'),
				type: 'success',
				placement: 'topRight',
				showProgress: true,
				pauseOnHover: true,
			});
		}
	}, [status]); // eslint-disable-line

	if (!joinedBrand) return null;

	return (
		<Drawer
			{...props}
			open={!!joinedBrand}
			onClose={() => setJoinedBrand(null)}
			width={650}
			title={t('Заявка на подключение')}>
			<JoinForm
				brand={joinedBrand}
				isLoading={isLoading}
				sourceOptions={sourceOptions}
				onJoin={joinBrands}
				onClose={() => setJoinedBrand(null)}
			/>
		</Drawer>
	);
};
